import styled from 'styled-components';

export const Label = styled.span`
  font-family: ${(props) => props.theme.fonts.sansSerif};
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.8rem;
  display: flex;
  position: relative;
  left: 5px;
  display: none;
  color: ${(props) => props.theme.colors.red};
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  &:hover {
    div {
      background: var(--red);
      border: 2px solid var(--red);
    }
    svg {
      fill: #fff;
    }

    .info,
    .wishlist {
      path {
        fill: #fff;
      }
    }

    ${Label} {
      display: flex;
    }
  }
`;
